import(/* webpackMode: "eager" */ "/microservice/node_modules/.pnpm/@pamperedchef+design-system@4.0.124_@react-aria+button@3.13.3_@react-spectrum+provider@3.11.1_m6hbw6xviqrdp4gds4zwopixpi/node_modules/@pamperedchef/design-system/design-system.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/microservice/node_modules/.pnpm/next-intl@4.13.0_@swc+helpers@0.5.23_next@15.5.15_@babel+core@7.29.7_@playwright+test@1.60.0__ac3fyghtpedkaotfldcd7pe6u4/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/microservice/node_modules/.pnpm/next@15.5.15_@babel+core@7.29.7_@playwright+test@1.60.0_react-dom@19.2.7_react@19.2.7__react@19.2.7_sass@1.101.0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["PageView"] */ "/microservice/src/app/components/analytics/page-view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MotionConfig"] */ "/microservice/src/app/components/client/index.ts");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsManager"] */ "/microservice/src/app/components/shared/analytics-manager/client.tsx");
;
import(/* webpackMode: "eager" */ "/microservice/src/app/components/shared/error-boundary/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavTracker"] */ "/microservice/src/app/components/shared/nav-tracker/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserManager"] */ "/microservice/src/app/components/shared/user-manager/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AddToCartSliderRoot"] */ "/microservice/src/app/features/cart/AddToCartSliderRoot/AddToCartSliderRoot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartEventBridge"] */ "/microservice/src/app/features/cart/CartEventBridge/CartEventBridge.tsx");
;
import(/* webpackMode: "eager" */ "/microservice/src/styles/main.scss");
